import type * as React from 'react'
import type {MeasuredComponentProps} from 'react-measure'

import {OneLineContext} from '../contexts/oneLine'

import {withContentRect} from './Measure'

const BREAK_POINT = 1200
type OwnProps = React.HTMLAttributes<HTMLDivElement>
type Props = OwnProps & MeasuredComponentProps

function OneLineDetector({measureRef, contentRect, measure, children, ...props}: Props) {
  const width = contentRect.client?.width ?? 0
  return (
    <div ref={measureRef} {...props}>
      <OneLineContext.Provider value={width > 0 ? width >= BREAK_POINT : null}>
        {children}
      </OneLineContext.Provider>
    </div>
  )
}

export default withContentRect<OwnProps>('client')(OneLineDetector)
